import React, { useEffect, useMemo, useState } from 'react';
import classes from './SelectedSalesOrder.module.css';
import moment from 'moment/moment';
import { HistoryTable } from './HistoryTable';
import { SalesOrderInfo, selectServicesTranslations } from '../../../store/slices/salesOrders';
import { useAppSelector } from '../../../store/store';

import { IAccountInfo, selectAccountInfo } from '../../../store/slices/auth';
import { client } from '../../../networking/client';
import { IAttachment } from './DigitalHealthProfileTab';
import { DocumentList } from '../../DocumentList/DocumentList';
import { useTranslation } from '../../../hooks/useTranslations';
import { buildTranslatedServicesMap, getTranslatedServicesName } from '../../../utils/miscUtils';

interface Props {
  selectedSalesOrder: SalesOrderInfo;
  isInConsultations?: boolean;
}
export interface IDocumentAttachments {
  amount: number;
  attachments: IAttachment[];
  booking_date: Date;
  currency: string;
  end: Date;
  external_reference: string;
  product_amount: number;
  product_group: string;
  product_id: number;
  product_name: string;
  record_state: string;
  sample_date?: Date;
  start: Date;
  statement_text: string;
  ta_id: number;
  transaction_id: number;
  type_of_test: string;
  product_order_item_id_out: number;
  product_order_id_out: number;
}

export const AppointmentDetailsTab: React.FC<Props> = ({
  selectedSalesOrder,
  isInConsultations,
}) => {
  const { translations } = useTranslation();
  const accountInfo = useAppSelector<IAccountInfo>(selectAccountInfo);
  const [documents, setDocuments] = useState<IDocumentAttachments[]>([]);
  const lang = localStorage.getItem('lang') || 'en';
      const servicesTranslations = useAppSelector(selectServicesTranslations);
    const translatedServicesMap = useMemo(
    () => buildTranslatedServicesMap(servicesTranslations, lang),
    [servicesTranslations, lang]
  );
  
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await client.get(
          `/core/healthpoint/customer/${selectedSalesOrder?.customer_person.person_account_number}/product_orders?product_order_id=${selectedSalesOrder?.sales_order.sales_order_external_id}&product_order_item_id=${selectedSalesOrder?.sales_order_item.external_sales_order_item_id}&customer_ta_id=${selectedSalesOrder?.sales_order.ta_id}`
        );
        setDocuments(response?.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDocuments();
  }, [selectedSalesOrder, accountInfo]);

  const attachmentsWithDocuments = documents?.find(
    (item: IDocumentAttachments) =>
      item.transaction_id == selectedSalesOrder.sales_order.transaction_id &&
      item.product_order_item_id_out ==
        selectedSalesOrder.sales_order_item.external_sales_order_item_id
  );
  const displayDocuments = attachmentsWithDocuments?.attachments?.filter(
    (att) => !att.is_uploaded_by_doctor
  );
  // ?.filter(
  // (att: IAttachment) => att.attachment_type_id === 15
  // );
  return (
    <>
      <div className={classes.tabContentSection}>
        <div className={classes.tabHeader}>{translations('appointment.details')}</div>
        <div className={classes.appointmentTopicContainer}>
          <div className={classes.appointmentsTopicLeftSide}>
            <div className={classes.appointmentTopicRow}>
              <div className={classes.appointmentTopicRowItem}>
                <div className={classes.appointmentTopicRowItemText1}>
                  {translations('appointment.id')}
                </div>
                <div className={classes.appointmentTopicRowItemText2}>
                  {selectedSalesOrder.sales_order.sales_order_id}
                </div>
              </div>
              <div className={classes.appointmentTopicRowItem}>
                <div className={classes.appointmentTopicRowItemText1}>
                  {translations('patient')}
                </div>
                <div className={classes.appointmentTopicRowItemText2}>
                  {selectedSalesOrder.customer_person.person_firstname}{' '}
                  {selectedSalesOrder.customer_person.person_lastname}
                </div>
              </div>
            </div>
            <div className={classes.appointmentTopicRow}>
              <div className={classes.appointmentTopicRowItem}>
                <div className={classes.appointmentTopicRowItemText1}>
                  {translations('service')}
                </div>
                <div className={classes.appointmentTopicRowItemText2}>
                  {getTranslatedServicesName(
                                            selectedSalesOrder.service.service_id,
                                           translatedServicesMap
                                          )}
                </div>
              </div>
              <div className={classes.appointmentTopicRowItem}>
                <div className={classes.appointmentTopicRowItemText1}>
                  {translations(
                    selectedSalesOrder?.sales_order_appointment.start ? 'date' : 'date_time'
                  )}
                </div>
                <div className={classes.appointmentTopicRowItemText2}>
                  {selectedSalesOrder?.sales_order_appointment.start
                    ? moment(selectedSalesOrder.sales_order_appointment.start)
                        .locale(lang)
                        .format('DD.MM.YYYY')
                    : translations('walkin_appointment')}
                </div>
              </div>
            </div>
            {selectedSalesOrder.sales_order_appointment.start && (
              <div className={classes.appointmentTopicRow}>
                <div className={classes.appointmentTopicRowItem}>
                  <div className={classes.appointmentTopicRowItemText1}>{translations('time')}</div>
                  <div className={classes.appointmentTopicRowItemText2}>
                    {moment(selectedSalesOrder.sales_order_appointment.start).format('HH:mm')}
                    {' - '}
                    {moment(selectedSalesOrder.sales_order_appointment.end_time).format('HH:mm')}
                  </div>
                </div>
                <div className={classes.appointmentTopicRowItem}>
                  <div className={classes.appointmentTopicRowItemText1}>
                    {translations('count')}
                  </div>
                  <div className={classes.appointmentTopicRowItemText2}>
                    {moment(selectedSalesOrder.sales_order_appointment.start)
                      .locale(lang)
                      .fromNow()}
                  </div>
                </div>
              </div>
            )}
            {displayDocuments?.length !== 0 && (
              <>
                <div className={classes.tabHeader} style={{ paddingLeft: 0, paddingTop: 20 }}>
                  {translations('documents')}
                </div>
                {displayDocuments && (
                  <DocumentList
                    documents={displayDocuments}
                    userInfo={{
                      person_firstname: selectedSalesOrder?.customer_person?.person_firstname,
                      person_lastname: selectedSalesOrder?.customer_person?.person_lastname,
                    }}
                  />
                )}
              </>
            )}
          </div>
          {/*<div className={classes.appointmentsTopicRightSide}>*/}
          {/*  {isLoading ? (*/}
          {/*    <Spinner />*/}
          {/*  ) : (*/}
          {/*    <PrimaryButtonV2*/}
          {/*      disabled={*/}
          {/*        !isCarePointVideoConsultation*/}
          {/*          ? selectedSalesOrder.work_order?.work_order_status_id === 2 ||*/}
          {/*            userRole === 'care center agent'*/}
          {/*          : !eyesonGuestToken*/}
          {/*      }*/}
          {/*      text={*/}
          {/*        // !selectedSalesOrder.work_order*/}
          {/*        //   ? translations('prepare.consultation')*/}
          {/*        //   : selectedSalesOrder.service_service_group.service_group_id === 8*/}
          {/*        //   ? translations('start.consultation')*/}
          {/*        //   : translations('start.video.consultation')*/}
          {/*        accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION*/}
          {/*          ? translations('prepare.consultation')*/}
          {/*          : selectedSalesOrder.service_service_group.service_group_id === 8*/}
          {/*          ? translations('start.consultation')*/}
          {/*          : translations('start.video.consultation')*/}
          {/*      }*/}
          {/*      onClick={() => {*/}
          {/*        if (accountInfo?.account_number === process.env.REACT_APP_VITAL_SIGN_LOCATION) {*/}
          {/*          dispatch(*/}
          {/*            createWorkOrderService({*/}
          {/*              serviceId: selectedSalesOrder?.service.service_id,*/}
          {/*              salesOrderId: selectedSalesOrder?.sales_order.sales_order_id,*/}
          {/*              personId: selectedSalesOrder?.sales_order.business_person_id,*/}
          {/*              businessPartnerId: businessPartnerId,*/}
          {/*            })*/}
          {/*          );*/}
          {/*          return;*/}
          {/*        }*/}
          {/*        dispatch(*/}
          {/*          createWorkOrderService({*/}
          {/*            serviceId: selectedSalesOrder?.service.service_id,*/}
          {/*            salesOrderId: selectedSalesOrder?.sales_order.sales_order_id,*/}
          {/*            personId: selectedSalesOrder?.sales_order.business_person_id,*/}
          {/*            businessPartnerId: businessPartnerId,*/}
          {/*          })*/}
          {/*        );*/}
          {/*        // else if (isCarePointVideoConsultation) {*/}
          {/*        //   navigate('/web/guest-video-consulting-room', {*/}
          {/*        //     state: {*/}
          {/*        //       salesOrder: { ...selectedSalesOrder },*/}
          {/*        //       roomData: {},*/}
          {/*        //       guestToken: eyesonGuestToken,*/}
          {/*        //     },*/}
          {/*        //   });*/}
          {/*        // }*/}
          {/*      }}*/}
          {/*      containerStyle={{*/}
          {/*        alignItems: 'center',*/}
          {/*        paddingLeft: 30,*/}
          {/*        paddingRight: 30,*/}
          {/*      }}*/}
          {/*      buttonStyle={{*/}
          {/*        minWidth: 200,*/}
          {/*        fontSize: 16,*/}
          {/*        height: 50,*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*</div>*/}
        </div>
      </div>
      <div className={classes.tabContentSection}>
        <div className={classes.tabHeader}>{translations('appointment.history')}</div>
        <div className={classes.appointmentTopicContainer}>
          <HistoryTable
            customer_person_id={selectedSalesOrder.customer_person.person_id}
            isInConsultation={isInConsultations}
          />
        </div>
      </div>
    </>
  );
};
